import {
    VIEW_REPORT,
    VIEW_REPORT_SUCCESS,
    VIEW_REPORT_FAILURE,
    VIEW_REPORT_SHOW_HIDE,
    VIEW_REPORT_RESET,
    VIEW_REPORT_HISTORY,
} from '../actions';

const initialState = {
    loading: false,
    statusCode: '',
    statusMessage: '',
    viewReportData: '',
    viewReportBackNavigate: '',
    viewReportOpen: false,
    viewReportHistory: [],
};

const ViewReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case VIEW_REPORT:
            return {
                ...state,
                loading: true,
            };
        case VIEW_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                viewReportData: action.payload,
            };
        case VIEW_REPORT_FAILURE:
            return {
                ...state,
                loading: false,
            };
        case VIEW_REPORT_SHOW_HIDE:
            return {
                ...state,
                ...action.payload,
            };
        case VIEW_REPORT_HISTORY:
            return {
                ...state,
                viewReportHistory: action.payload.reportHistory,
            };
        case VIEW_REPORT_RESET:
            return {
                ...state,
                viewReportData: initialState.viewReportData,
                viewReportBackNavigate: initialState.viewReportBackNavigate,
                viewReportOpen: initialState.viewReportOpen,
                viewReportHistory: initialState.viewReportHistory,
            };
        default:
            return {
                ...state,
            };
    }
};

export default ViewReportReducer;
